import React from 'react';
import { useFetchHelpDoc } from '../Hooks/common/useFetchHelpDoc';
import Spinner from '../common/Spinner';

// TODO: WIP make a common component for both changelogs/help and likes 
//and pass the string from calling component,

const ChangeLogPdf = () => {

    const doc = "ChangeLog";
    const changeLog = useFetchHelpDoc(doc);
    const changeLogData = changeLog?.data;


    return (
        <div className="grid min-h-screen place-items-center">
            {changeLog?.isLoading && (
                <Spinner text="Loading Data... Pls wait" />
            )}
            {changeLog?.isError && (
                <p className="text-red-500">Problem with query. Please try again later.</p>
            )}
            {changeLog?.isSuccess && changeLogData ? (
                <iframe className="w-full h-full"
                    src={changeLogData}
                    title={doc}
                    allowFullScreen={true} />
            ) : (
                !changeLog?.isLoading && !changeLog?.isError && (
                    <p className="text-red-500">No data available.</p>
                )
            )}
        </div>
    );
};

export default ChangeLogPdf;